
import React from 'react';
import { FaEdit, FaTrash, FaKey, FaMapMarked } from 'react-icons/fa';
import './SportsManagementStyle.scss';

const RegionalUserListTable = React.memo(({ users, handleOpenModal, handleOpenPasswordModal, handleOpenRegionsModal, handleDelete }) => {
    return (
        <div className="table-responsive">
            <table className="data-table">
                <thead>
                    <tr>
                        <th>Kullanıcı Adı</th>
                        <th>Ad Soyad</th>
                        <th>E-posta</th>
                        <th>Atanan Bölgeler</th>
                        <th>Durum</th>
                        <th>İşlemler</th>
                    </tr>
                </thead>
                <tbody>
                    {users.map(user => (
                        <tr key={user.id}>
                            <td>{user.username}</td>
                            <td>{user.firstName} {user.lastName}</td>
                            <td>{user.email}</td>
                            <td>
                                {user.assignedRegions && user.assignedRegions.length > 0 ? (
                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                                        {user.assignedRegions.map(r => (
                                            <span key={r.regionId} style={{ 
                                                background: '#e0e7ff', 
                                                color: '#3730a3',
                                                padding: '2px 8px',
                                                borderRadius: '4px',
                                                fontSize: '0.8rem'
                                            }}>
                                                {r.regionName}
                                            </span>
                                        ))}
                                    </div>
                                ) : <span style={{ color: '#999' }}>Yok</span>}
                            </td>
                            <td>
                                <span className={`status-badge ${user.isActive ? 'active' : 'inactive'}`}>
                                    {user.isActive ? 'Aktif' : 'Pasif'}
                                </span>
                            </td>
                            <td className="actions-cell">
                                <div className="action-buttons-wrapper">
                                    <button className="btn-premium btn-sm btn-outline" onClick={() => handleOpenModal(user)} title="Düzenle">
                                        <FaEdit />
                                    </button>
                                    <button className="btn-premium btn-sm btn-info" onClick={() => handleOpenPasswordModal(user)} title="Şifre Değiştir">
                                        <FaKey />
                                    </button>
                                    <button className="btn-premium btn-sm btn-success" onClick={() => handleOpenRegionsModal(user)} title="Bölge Ata">
                                        <FaMapMarked />
                                    </button>
                                    <button className="btn-premium btn-sm btn-danger" onClick={() => handleDelete(user.id)} title="Sil">
                                        <FaTrash />
                                    </button>
                                </div>
                            </td>
                        </tr>
                    ))}
                    {users.length === 0 && (
                        <tr>
                            <td colSpan="6" className="text-center">Kullanıcı bulunamadı.</td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
});

export default RegionalUserListTable;
